module.exports = __webpack_public_path__ + "img/media-pic-7.c53a0100.png";